import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { AbilityProvider } from "../lib/AbilityProvider";
import { Button, Dialog, DialogTrigger, Modal } from "react-aria-components";
import useProfile from "../lib/useProfile";
import Lists from "../features/Lists";
import { Tooltip } from "react-tooltip";
import { signOut } from "../api/api-hooks";
// import Header from "../features/header/Header";

// Define types for props where necessary
interface SideBarUiProps {
  handleOpen: () => void;
}

interface SidebarProps {
  handleOpen: () => void;
  isMainSidebarOpen: boolean;
  setIsMainSidebarOpen: any;
  isSidebarOpen: boolean;
}

const DefaultLayout: React.FC = () => {
  const { hasAuthenticated, setUserDetails, userDetails } = useAuth();
  const { profile } = useProfile();

  const [openNav, setOpenNav] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);

  const [isMainSidebarOpen, setIsMainSidebarOpen] = useState(true);
  const isSidebarOpen = true;

  const handleOpen = () => {
    if (isMobileView) {
      setOpenNav(!openNav);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (profile && hasAuthenticated) {
      setUserDetails(profile);
    }
  }, [profile, hasAuthenticated, userDetails, setUserDetails]);

  return (
    <AbilityProvider>
      <div className=" md:h-[100vh] w-[100vw] h-[100svh]  ">
        <div className="flex items-stretch h-full w-full">
          {openNav ? <SideBarUi handleOpen={handleOpen} /> : null}
          <div className="hidden md:block h-full fixed">
            <Sidebar
              handleOpen={handleOpen}
              isMainSidebarOpen={isMainSidebarOpen}
              setIsMainSidebarOpen={setIsMainSidebarOpen}
              isSidebarOpen={isSidebarOpen}
            />
          </div>
          {/* <div className="flex flex-col w-full bg-[#fefefe] overflow-y-hidden md:overflow-y-auto"> */}
          <div
            className={`flex flex-col items-center md:max-w-7xl mx-auto w-full ${
              isMainSidebarOpen ? "ml-80" : ""
            } `}
          >
            {/* <div className="bg-white w-full justify-between text-black h-12 flex items-center gap-3 py-6 p-5">
              <Header />
            </div> */}

            <main className="flex-grow bg-white p-5 w-full mx-auto">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </AbilityProvider>
  );
};

export default DefaultLayout;

const SideBarUi: React.FC<SideBarUiProps> = ({ handleOpen }) => {
  return (
    <div className="absolute z-50 min-h-screen border w-full md:hidden bg-white flex flex-col justify-between gap-10 font-semibold top-0">
      <div className="p-0 h-full">
        <div className="w-screen p-4 pb-0 fixed bg-white h-fit z-50 border-b-border border-b-[0.5px]">
          <div className="w-full flex justify-between pb-4 text-[16px] font-normal text-[#4E4E4E]">
            Roles
            <button onClick={handleOpen} className="flex w-full justify-end">
              <img
                src="/icons/mob-close.svg"
                alt="close"
                className="w-7 h-7 md:hidden"
              />
            </button>
          </div>
        </div>
        <div className="max-w-md flex flex-col explore-content mobile-roles overflow-y-scroll pt-16 px-4">
          User
        </div>
      </div>
    </div>
  );
};

// const Sidebar: React.FC<SidebarProps> = ({ handleOpen }) => {
//   const [isMainSidebarOpen, setIsMainSidebarOpen] = useState(true);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);

//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [expanded, setExpanded] = useState(false);
//   const { loading } = useProfile();

//   const { logout, userDetails, hasAuthenticated } = useAuth();

//   const navigate = useNavigate();

//   const toggleMainSidebar = () => {
//     setIsMainSidebarOpen(!isMainSidebarOpen);
//     setExpanded(!expanded);
//   };

//   const handleLogout = (e: any) => {
//     logout();
//     setIsPopupOpen(!isPopupOpen);
//     navigate("/", { replace: true });
//   };

//   const handleRedirect = (path: any) => {
//     navigate(path);
//   };

//   const handleMouseEnter = () => {
//     if (!expanded) {
//       setIsMainSidebarOpen(true);
//     }
//   };

//   const handleMouseLeave = () => {
//     if (!expanded) {
//       setIsMainSidebarOpen(false);
//     }
//   };

//   return (
//     <div
//       className={`${
//         isMainSidebarOpen ? "w-[252px]" : "w-[56px]"
//       } h-full bg-white overflow-y-auto flex`}
//     >
//       <div
//         onClick={toggleMainSidebar}
//         className={`absolute rounded-full flex justify-around items-center cursor-pointer z-[1] top-[55px] collapse-btn ${
//           isMainSidebarOpen ? "" : "close"
//         }`}
//       >
//         <img
//           src="/icons/sb-collapse.svg"
//           alt="collapse"
//           className="w-[24px] h-[24px]"
//           style={{
//             transform: isMainSidebarOpen ? "rotate(0deg)" : "rotate(180deg)",
//           }}
//         />
//       </div>
//       <div
//         onMouseEnter={handleMouseEnter}
//         onMouseLeave={handleMouseLeave}
//         className="flex w-full"
//       >
//         <div
//           className={`sidebar custom-scrollbar-sidebar ${
//             isMainSidebarOpen ? "" : "collapsed"
//           } w-[252px] relative py-4 bg-white h-full justify-between flex flex-col overflow-y-auto`}
//           id="sidebar"
//         >
//           <div className="flex-col">
//             <div className="flex gap-0">
//               <button
//                 className={`flex items-center mt-[-2px] ${
//                   isMainSidebarOpen ? "mx-4 justify-between" : "justify-around"
//                 }`}
//               >
//                 <div className="w-[32px] h-[32px]">
//                   <img
//                     src="/icons/Logo.svg"
//                     alt="logo"
//                     className=""
//                     style={{ width: "32px", height: "32px" }}
//                   />
//                 </div>
//               </button>
//             </div>

//             {/* <button
//               className={`border-[1.5px] p-3 py-2 mt-4 border-border bg-overall mx-4 justify-between w-[88%] flex rounded-full items-center ${
//                 isMainSidebarOpen ? "" : "hidden"
//               }`}
//             >
//               <div className="text-[#6E6E6E] text-[14px] font-normal leading-[16.71px] ml-[2px]">
//                 New Chat
//               </div>
//               {!isMainSidebarOpen && (
//                 <div className="w-[24px] justify-around">
//                   <img
//                     src="/icons/new-chat.svg"
//                     alt="new chat plus"
//                     className="w-[24px]"
//                   />
//                 </div>
//               )}
//             </button> */}

//             <div
//               className={`${
//                 isSidebarOpen && isMainSidebarOpen ? " mt-5" : " "
//               } flex gap-2 items-center

//               `}
//             >
//               <Lists
//                 isOpen={isSidebarOpen && isMainSidebarOpen}
//                 source="/icons/Projects.svg"
//                 placeholder="Users"
//               />
//             </div>

//             {hasAuthenticated ? (
//               loading || !userDetails?.username ? (
//                 <div
//                   className={`${
//                     isSidebarOpen && isMainSidebarOpen
//                       ? "flex items-center gap-2 px-4 py-3 w-full"
//                       : "justify-around"
//                   } flex justify-between items-center`}
//                 >
//                   <div className="flex gap-2 items-center">
//                     <div className={`w-[24px]`}>
//                       <div className="inset-0 flex items-center gap-4 animate-pulse w-full ">
//                         <div className="h-[24px] bg-[#8F8F8F22] rounded-[4px] w-full"></div>
//                       </div>
//                     </div>
//                     <div className={`w-[100px]`}>
//                       <div className="inset-0 flex items-center gap-4 animate-pulse w-full ">
//                         <div className="h-[24px] bg-[#8F8F8F22] rounded-[4px] w-full"></div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className={`w-[24px] mr-2`}>
//                     <div className="inset-0 flex items-center gap-4 animate-pulse w-full">
//                       <div className="h-[24px] bg-[#8F8F8F22] rounded-[4px] w-full"></div>
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className={`${
//                     isSidebarOpen && isMainSidebarOpen
//                       ? "flex items-center gap-2 px-4 pb-2 w-full"
//                       : "justify-around"
//                   } flex justify-between items-center`}
//                 >
//                   <div className="flex gap-2 items-center">
//                     <img
//                       src="/icons/profile-img.svg"
//                       alt="logo"
//                       className="rounded-full"
//                       style={{ width: "24px", height: "24px" }}
//                     />
//                     <div
//                       className={`${
//                         isSidebarOpen && isMainSidebarOpen ? "flex" : "hidden"
//                       } flex-col gap-2 text-[#656C78]`}
//                     >
//                       <p className="text-primary text-[14px] font-normal m-0">
//                         {userDetails?.username
//                           ? userDetails.username
//                           : userDetails?.email.split("@")[0]}
//                       </p>
//                     </div>
//                   </div>
//                   <DialogTrigger>
//                     <Button
//                       className={`${
//                         isSidebarOpen && isMainSidebarOpen ? "" : "hidden"
//                       } flex gap-3 items-center cursor-pointer hover:rounded-full p-2 pr-2 hover:bg-[#4248501A] focus:outline-none `}
//                       id="logout"
//                     >
//                       <img
//                         src="/icons/logout.svg"
//                         alt="logout"
//                         className={`${
//                           isSidebarOpen && isMainSidebarOpen ? "open" : "hidden"
//                         } w-[24px]`}
//                       />
//                       <Tooltip id="tooltip-logout" anchorSelect="#logout">
//                         <button className="text-xs">Logout</button>
//                       </Tooltip>
//                     </Button>
//                     <Modal>
//                       <Dialog>
//                         {({ close }) => (
//                           <div className="flex flex-col gap-3 w-[650px] rounded-mid p-8 bg-[#FFFFFF] border border-border text-[#8C939F] pt-4">
//                             <div className="flex justify-between">
//                               <h3 className="font-normal text-[24px] text-[#64645E] leading-[28.64px]">
//                                 Logging Out! Ready to take a break?
//                               </h3>
//                               <Button
//                                 className="focus:outline-none"
//                                 onPress={() => close()}
//                               >
//                                 <img
//                                   src="/icons/popup-close.svg"
//                                   alt="close"
//                                   className="w-[24px]"
//                                 />
//                               </Button>
//                             </div>
//                             <div className="flex gap-3 items-center p-4 border-[1.5px] border-border w-fit rounded-normal">
//                               <img
//                                 src="/icons/profile-img.svg"
//                                 alt="logo"
//                                 className="rounded-full"
//                                 style={{ width: "24px", height: "24px" }}
//                               />
//                               <div className="flex-col gap-2 text-[#656C78]">
//                                 {userDetails?.username && (
//                                   <p className="text-primary text-[14px] leading-[25.2px] font-light">
//                                     {userDetails?.username}
//                                   </p>
//                                 )}
//                                 <p className="text-primary text-[14px] leading-[25.2px] font-light">
//                                   {userDetails?.email}
//                                 </p>
//                               </div>
//                             </div>
//                             <div className="text-[#64645E] font-light text-[14px] leading-[16.71px]">
//                               We'll keep everything safe and sound for you. Just
//                               confirm below when you're ready to log out
//                             </div>
//                             <div className="flex flex-end items-center justify-end pt-2">
//                               <Button
//                                 type="submit"
//                                 onPress={(e) => {
//                                   handleLogout(e);
//                                   close();
//                                 }}
//                                 className="modal-btn focus:outline-none"
//                               >
//                                 Confirm
//                               </Button>
//                             </div>
//                           </div>
//                         )}
//                       </Dialog>
//                     </Modal>
//                   </DialogTrigger>
//                 </div>
//               )
//             ) : (
//               <div
//                 className={`${
//                   isSidebarOpen && isMainSidebarOpen ? "" : "hidden"
//                 } flex items-center justify-center w-full space-x-4 text-[14px] pt-2`}
//               >
//                 <div className="w-auto">
//                   <button
//                     onClick={() => handleRedirect("/register")}
//                     className="gradient-btn"
//                   >
//                     Sign up
//                   </button>
//                 </div>
//                 <div className="w-auto">
//                   <button
//                     onClick={() => handleRedirect("/login")}
//                     className="gradient-border"
//                   >
//                     <div className="text-grad">Sign in</div>
//                   </button>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

const Sidebar: React.FC<SidebarProps> = ({
  handleOpen,
  isMainSidebarOpen,
  setIsMainSidebarOpen,
  isSidebarOpen,
}) => {
  // const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [expanded, setExpanded] = useState(false);
  const { loading } = useProfile();

  const { logout, userDetails, hasAuthenticated } = useAuth();
  const navigate = useNavigate();

  // const toggleMainSidebar = () => {
  //   setIsMainSidebarOpen(!isMainSidebarOpen);
  //   setExpanded(!expanded);
  // };

  const handleLogout = async (e: any) => {
    await signOut();
    logout();
    setIsPopupOpen(!isPopupOpen);
    navigate("/", { replace: true });
  };

  const handleRedirect = (path: any) => {
    navigate(path);
  };

  // const handleMouseEnter = () => {
  //   if (!expanded) {
  //     setIsMainSidebarOpen(true);
  //   }
  // };

  // const handleMouseLeave = () => {
  //   if (!expanded) {
  //     setIsMainSidebarOpen(false);
  //   }
  // };

  const handleHomePage = () => {
    navigate("/dashboard");
  };

  return (
    <div
      className={`${
        isMainSidebarOpen ? "w-[252px]" : "w-[88px]"
      } h-full bg-[#f0f4f8] overflow-y-auto flex flex-col border-r border-gray-300`}
    >
      {/* <div
        onClick={toggleMainSidebar}
        className={`absolute rounded-full  flex justify-around items-center cursor-pointer z-[1] top-[55px] collapse-btn w-fit ${
          isMainSidebarOpen ? "" : "close"
        }`}
      >
        <div className="w-max h-max">
        <img
          src="/icons/sb-collapse.svg"
          alt="collapse"
          className="w-[24px] h-[24px]"
          style={{
            transform: isMainSidebarOpen ? "rotate(0deg)" : "rotate(180deg)",
          }}
        />
        </div>
      </div> */}
      <div
        // onMouseEnter={handleMouseEnter}
        // onMouseLeave={handleMouseLeave}
        className="flex-grow flex w-full"
      >
        <div
          className={`sidebar custom-scrollbar-sidebar ${
            isMainSidebarOpen ? "" : "collapsed"
          } w-[252px] relative py-4 bg-[#f0f4f8] h-full justify-between flex flex-col`}
          id="sidebar"
        >
          <div className="flex-col">
            <div className="flex gap-0 px-4">
              <button
                onClick={(event) => handleHomePage()}
                className={`flex items-center mt-[-2px] ${
                  isMainSidebarOpen ? " justify-between" : "justify-between"
                } px-4 pl-3`}
              >
                <div className="w-[32px] h-[32px]">
                  <img
                    src="/icons/Logo.svg"
                    alt="logo"
                    className=""
                    style={{ width: "32px", height: "32px" }}
                  />
                </div>
              </button>
              {/* {isMainSidebarOpen && (
                <button
                  className="ml-auto text-gray-700 hover:bg-gray-200 p-2 rounded-full"
                  onClick={toggleMainSidebar}
                >
                  <img
                    src="/icons/file-text.svg"
                    alt="File Text"
                    className="h-6 w-6"
                  />
                </button>
              )} */}
            </div>

            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? "mt-2" : " mt-5"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/admin/dashboard"
                placeholder="Dashboard"
                redirect="/dashboard"
              />
            </div>

            {/* <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-5" : " "
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/"
                placeholder="Organization"
                redirect="/organization"
              />
            </div> */}

            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : " mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/admin/registered-user"
                placeholder="Users"
                redirect="/users?status=active"
              />
            </div>

            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/admin/active-session"
                placeholder="Sessions"
                redirect="/sessions"
              />
            </div>

            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/admin/chat"
                placeholder="Chats"
                redirect="/chats?agent=false"
              />
            </div>

            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/admin/chat"
                placeholder="Agents"
                redirect="/chats?agent=true"
              />
            </div>
            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/admin/project"
                placeholder="Projects"
                redirect="/projects"
              />
            </div>
            {/* <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/admin/research"
                placeholder="Research"
                redirect="/research"
              />
            </div> */}

            {/* <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/roles"
                placeholder="Roles"
                redirect="/roles"
              />
            </div> */}
            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/feedback"
                placeholder="Feedback"
                redirect="/feedback"
              />
            </div>
            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/mails"
                placeholder="Mails"
                redirect="/mails"
              />
            </div>
            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/request-demo"
                placeholder="Request Demo"
                redirect="/request-demo"
              />
            </div>
            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/send-mail"
                placeholder="Invite Users"
                redirect="/send-mail"
              />
            </div>
            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source="/email-invites-sent"
                placeholder="Email Invites Sent"
                redirect="/email-invites-sent"
              />
            </div>
            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source=""
                placeholder="Maintenance"
                redirect="/maintenance"
              />
            </div>
            {/* <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source=""
                placeholder="Feature Tracking"
                redirect="/feature"
              />
            </div>
            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source=""
                placeholder="Prompt Analytics"
                redirect="/prompts"
              />
            </div>
            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source=""
                placeholder="Engagement Metrics"
                redirect="/engagement"
              />
            </div>
            <div
              className={`${
                isSidebarOpen && isMainSidebarOpen ? " mt-2" : "mt-2"
              } flex gap-2 items-center`}
            >
              <Lists
                isOpen={isSidebarOpen && isMainSidebarOpen}
                source=""
                placeholder="View tables"
                redirect="/tables"
              />
            </div> */}
          </div>

          <div className="mt-auto pb-4">
            {hasAuthenticated ? (
              loading || !userDetails?.username ? (
                <div
                  className={`${
                    isSidebarOpen && isMainSidebarOpen
                      ? "flex items-center gap-2 px-4 py-3 w-full"
                      : "justify-around"
                  } flex justify-between items-center h-10`}
                >
                  <div className="flex gap-2 items-center">
                    <div className="w-[24px]">
                      <div className="inset-0 flex items-center gap-4 animate-pulse w-full ">
                        <div className="h-[24px] bg-[#8F8F8F22] rounded-[4px] w-full"></div>
                      </div>
                    </div>
                    <div className="w-[100px]">
                      <div className="inset-0 flex items-center gap-4 animate-pulse w-full ">
                        <div className="h-[24px] bg-[#8F8F8F22] rounded-[4px] w-full"></div>
                      </div>
                    </div>
                  </div>
                  <div className="w-[24px] mr-2">
                    <div className="inset-0 flex items-center gap-4 animate-pulse w-full">
                      <div className="h-[24px] bg-[#8F8F8F22] rounded-[4px] w-full"></div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={`flex items-center gap-2 px-4 w-full justify-between h-10`}
                >
                  <div className="flex gap-2 items-center px-4 py-2">
                    <img
                      src="/icons/profile-img.svg"
                      alt="logo"
                      className="rounded-full"
                      style={{ width: "24px", height: "24px" }}
                    />
                    <div
                      className={`${
                        isSidebarOpen && isMainSidebarOpen ? "flex" : "hidden"
                      } text-[#656C78]`}
                    >
                      <p className="text-primary text-[14px] font-normal m-0">
                        {userDetails?.username
                          ? userDetails.username
                          : userDetails?.email.split("@")[0]}
                      </p>
                    </div>
                  </div>
                  {/* <DialogTrigger>
                    <Button
                      className={`${
                        isSidebarOpen && isMainSidebarOpen ? "" : "hidden"
                      } flex gap-3 items-center cursor-pointer hover:rounded-full p-2 pr-2 hover:bg-[#4248501A] focus:outline-none `}
                      id="logout"
                    >
                      <img
                        src="/icons/logout.svg"
                        alt="logout"
                        className={`${
                          isSidebarOpen && isMainSidebarOpen ? "open" : "hidden"
                        } w-[24px]`}
                      />
                      <Tooltip id="tooltip-logout" anchorSelect="#logout">
                        <button className="text-xs">Logout</button>
                      </Tooltip>
                    </Button>
                    <Modal>
                      <Dialog>
                        {({ close }) => (
                          <div className="flex flex-col gap-3 w-[650px] rounded-mid p-8 bg-[#FFFFFF] border border-border text-[#8C939F] pt-4">
                            <div className="flex justify-between">
                              <h3 className="font-normal text-[24px] text-[#64645E] leading-[28.64px]">
                                Logging Out! Ready to take a break?
                              </h3>
                              <Button
                                className="focus:outline-none"
                                onPress={() => {
                                  close();
                                }}
                              >
                                <img
                                  src="/icons/popup-close.svg?v=1726835293747"
                                  alt="close"
                                  className="w-[24px]"
                                />
                              </Button>
                            </div>
                            <div className="flex gap-3 items-center p-4 border-[1.5px] border-border w-fit rounded-normal">
                              <img
                                src="/icons/profile-img.svg?v=1726835293747"
                                alt="logo"
                                className="rounded-full"
                                style={{ width: "24px", height: "24px" }}
                              />
                              <div className="flex-col gap-2 text-[#656C78]">
                                {userDetails?.username && (
                                  <p className="text-primary text-[14px] leading-[25.2px] font-light">
                                    {userDetails?.username}
                                  </p>
                                )}
                                <p className="text-primary text-[14px] leading-[25.2px] font-light">
                                  {userDetails?.email}
                                </p>
                              </div>
                            </div>
                            <div className="text-[#64645E] font-light text-[14px] leading-[16.71px]">
                              We'll keep everything safe and sound for you. Just
                              confirm below when you're ready to log out
                            </div>
                            <div className="flex flex-end items-center justify-end pt-2">
                              <Button
                                type="submit"
                                onPress={(e) => {
                                  handleLogout(e);
                                  close();
                                }}
                                className="modal-btn-new text-white px-4 py-2 focus:outline-none"
                              >
                                Confirm
                              </Button>
                            </div>
                          </div>
                        )}
                      </Dialog>
                    </Modal>
                  </DialogTrigger> */}

                  <DialogTrigger>
                    <Button
                      className={`${
                        isSidebarOpen && isMainSidebarOpen ? "" : "hidden"
                      } flex items-center cursor-pointer hover:rounded-full hover:bg-[#4248501A] focus:outline-none w-fit p-2`}
                      id="logout"
                    >
                      <img
                        src="/icons/logout.svg?v=1726835293747"
                        alt="logout"
                        className={`${
                          isSidebarOpen && isMainSidebarOpen ? "open" : "hidden"
                        } w-[24px]`}
                      />
                      <Tooltip id="tooltip-logout" anchorSelect="#logout">
                        <button className="text-xs">Logout</button>
                      </Tooltip>
                    </Button>
                    <Modal>
                      <Dialog>
                        {({ close }) => (
                          <div className="flex flex-col gap-3 w-[650px] rounded-mid p-8 bg-[#FFFFFF] border border-border text-[#8C939F] pt-4 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50">
                            <div className="flex justify-between">
                              <h3 className="text-base font-normal leading-5 text-[#323232]">
                                Logging Out! Ready to take a break?
                              </h3>
                              <Button
                                className="focus:outline-none"
                                onPress={() => {
                                  close();
                                }}
                              >
                                <img
                                  src="/icons/popup-close.svg?v=1726835293747"
                                  alt="close"
                                  className="w-6 h-6"
                                />
                              </Button>
                            </div>
                            <div className="flex gap-3 items-center p-2 px-4 border border-[#E0E0E0] rounded">
                              <img
                                src="/icons/profile-img.svg?v=1726835293747"
                                alt="logo"
                                className="rounded-full"
                                style={{ width: "24px", height: "24px" }}
                              />
                              <div className="flex-col gap-2 text-[#656C78] inline">
                                <p className="text-[#323232] text-[14px] leading-[25.2px] font-light">
                                  {userDetails?.username} ({userDetails?.email})
                                </p>
                              </div>
                            </div>
                            <div className="text-[#323232] font-light text-[14px] leading-[20px]">
                              We'll keep everything safe and sound for you. Just
                              confirm below when you're ready to log out
                            </div>
                            <div className="flex flex-end items-center justify-end pt-2">
                              <Button
                                type="submit"
                                onPress={(e) => {
                                  handleLogout(e);
                                  close();
                                }}
                                className="h-[36px] w-[100px] bg-[#3F81FE] text-white rounded-sm hover:bg-[#3F81FE] text-xs font-medium leading-5 focus:outline-none"
                              >
                                Confirm
                              </Button>
                            </div>
                          </div>
                        )}
                      </Dialog>
                    </Modal>
                  </DialogTrigger>
                </div>
              )
            ) : (
              <div
                className={`${
                  isSidebarOpen && isMainSidebarOpen ? "" : "hidden"
                } flex items-center justify-center w-full space-x-4 text-[14px] pt-2`}
              >
                <div className="w-auto">
                  <button
                    onClick={() => handleRedirect("/register")}
                    className="gradient-btn"
                  >
                    Sign up
                  </button>
                </div>
                <div className="w-auto">
                  <button
                    onClick={() => handleRedirect("/login")}
                    className="gradient-border"
                  >
                    <div className="text-grad">Sign in</div>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
